import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}`;
const BACKEND_ORIGIN = API.endsWith("/api") ? API.slice(0, -4) : API;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Algo ha ido mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveBackendAssetUrl(url, version) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  const base = `${BACKEND_ORIGIN}${url}`;
  return version ? `${base}${base.includes("?") ? "&" : "?"}v=${encodeURIComponent(version)}` : base;
}
